import * as moment from 'moment';
import { TableVacancy } from '../core/services/vacancy/table-vacancy';

export class VacancyHelpers {

  static daysRemainingToDate( date: Date): number {
    const days = moment(date).diff(moment().startOf('d'), 'days');
    return days > 0 ? days : 0;
  }

  static daysRemainingCssClass( date: Date): string {
    const days = VacancyHelpers.daysRemainingToDate(date);
    return days < 10 ? 'sign-on-soon' : '';
  }


  static offerStatusString(statusId:number): string {
    const strings = {
      0: 'Passive',
      2: 'Urgent',
      1: 'Active'
    };

    return strings[statusId];
  }


  static offerStatusCssClass(statusId:number): string {
    const strings = {
      0: 'passive',
      1: 'active',
      2: 'urgent'
    };

    return strings[statusId];
  }


  static getRoleType( vacancy: TableVacancy ) {
    switch ( vacancy.role_type ) {
      case 31: // Company
        return 'C';
      case 32: // Company Representative
        return 'CR';
      case 33: // Freelancer
        return 'F';
    }
  }

}



// WEBPACK FOOTER //
// ./app/helpers/vacancyHelper.ts